// extracted by mini-css-extract-plugin
export default {"histogram":"histogram_histogram__SqvPs"};